<template>
    <button
        :disabled="processing || disabled"
        :type="type"
        :class="[{ 'cursor-not-allowed': processing || disabled, '': !processing && !disabled, '': !processing && !disabled, 'cursor-wait': processing }, classes, sizeClass, textColorClass]"
        class="focus:shadow-outline-gray duration-50 relative inline-flex items-center align-middle place-content-center font-semibold tracking-wide border border-transparent rounded-md focus:outline-none uppercase transition ease-in-out"
    >
        <span v-show="processing" class="absolute inset-0 flex items-center justify-center">
            <svg class="w-6 h-6 text-white animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" :stroke="color" stroke-width="4"></circle>
                <path class="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </span>
        <span class="inline-flex items-center" :class="{ 'opacity-5': processing }">
            <slot></slot>
            <slot name="icon"></slot>
        </span>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "submit",
        },
        color: {
            type: String,
            default: "brand",
        },
        size: {
            type: String,
            default: "base",
        },
        processing: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            if (this.color === "white") {
                return _.join(["bg-" + this.color, "ring-gray-500", "hover:bg-gray-150", "group-hover:bg-gray-150", "active:bg-gray-100", "disabled:bg-gray-300", "border-gray-300"], " ")
            }
            return _.join(["bg-" + this.color + "-500", "hover:bg-" + this.color + "-400", "active:bg-" + this.color + "-400", "disabled:bg-gray-300"], " ")
        },

        textColorClass() {
            return this.color === "white" ? "text-gray-600" : "text-white"
        },

        sizeClass() {
            if (this.size === "sm") {
                return "py-2 px-5 text-xs"
            }
            return "py-3 px-6 text-sm"
        },
    },
}
</script>
